import {useInfiniteQuery} from 'react-query';

import teamQuery from './teamQuery';
import teamKeys from './queryKeys';

function useFetchTeams(query) {
	const {
		search,
		teamTypeId,
		teamsIds,
		contentIds,
		userId,
		enabled,
		includeCalculatedTeams = false,
		...filter
	} = query;

	async function queryFn({pageParam}) {
		if (pageParam === false) {
			return {};
		}

		// Use the next page link, or recreate the request object
		const {items, next} = await teamQuery(
			'team',
			pageParam || {
				fields: [
					'id',
					'name',
					{
						teamType: ['id', 'name', 'colour'],
					},
					'smart_settings',
					'isSmartTeam',
					{
						userTeams: ['role'],
					},
					{
						contentTeams: ['isCalculated'],
					},
				],
				orderby: 'name',
				filter: {
					...filter,
					...(search && {name: `%${search}%`}),
					...(teamTypeId && {teamType_id: teamTypeId}),
					...(Array.isArray(teamsIds) && {id: teamsIds}),
				},
				join: {
					contentTeams: {
						isCalculated: includeCalculatedTeams ? [0, 1] : [0],
						assetDomains: {
							_required: true,
							...(Array.isArray(contentIds) && {
								asset_id: contentIds,
							}),
						},
					},
					...(userId && {
						userTeams: {
							user_id: userId,
						},
					}),
				},
			}
		);

		return {
			items,
			next,
		};
	}

	const queryKey = teamKeys.teams(query);

	const {data = {}, ...queryProps} = useInfiniteQuery(queryKey, queryFn, {
		getNextPageParam(lastPage) {
			return lastPage.next || false;
		},
		// don't refetch constantly when focussing/blurring the window
		staleTime: 60 * 1000,
		// If set to false, disables query from automatically running
		enabled,
	});

	const items =
		data.pages?.filter(page => page.items).flatMap(page => page.items) ||
		[];

	return {
		items,
		...queryProps,
	};
}

export default useFetchTeams;
